import React from "react";

type Props = {
  id: string;
  name: string;
  options: Array<[string, string]>;
  placeholder: string;
  selectClass: string;
  holderClass: string;
  changeHandler: (value: string) => void;
  value?: string;
};
const AdvancedSearchSelectInput: React.FC<Props> = ({
  id,
  name,
  options,
  placeholder,
  selectClass,
  holderClass,
  changeHandler,
  value,
}) => {
  const opts = options.map((val: [string, string], i: number) => (
    <option value={val[0]} key={i}>
      {val[1]}
    </option>
  ));
  return (
    <>
      <select
        className={value !== "" ? selectClass : holderClass}
        id={id}
        name={name}
        onChange={(e) => {
          changeHandler(e.target.value);
        }}
        value={value}
      >
        {placeholder ? <option>{placeholder}</option> : null}
        {opts}
      </select>
    </>
  );
};

export default AdvancedSearchSelectInput;
